<template>
	<div class="groupmenu">
		<WFScrollableArea ref="groupscroll" class="overflow-hidden">
			<div class="w-full p-36" v-if="currentGroup">
				<WFGroupPOIsMenu :group="currentGroup" :currentPOI="null">
					<template v-slot="slotProps" >
						<ListPOI :poi="slotProps.poi" @onPOIClick="onPOIClick" :class="{'wf-active': currentPOI && currentPOI.id == slotProps.poi.id}"></ListPOI>
					</template>
				</WFGroupPOIsMenu>
			</div>
			<div class="w-full p-36" v-if="!currentGroup">
				<WFAZMenu :currentPOI="null">
					<template v-slot="slotProps" >
						<ListPOI :poi="slotProps.poi" @onPOIClick="onPOIClick" :class="{'wf-active': currentPOI && currentPOI.id == slotProps.poi.id}"></ListPOI>
					</template>
				</WFAZMenu>
			</div>
		</WFScrollableArea>
		<div class="fixed">
			<!--WFSubGroupMenu v-if="currentGroup" :parent="currentGroup ? currentGroup.id : -1" :currentPOI="currentPOI" :showPOIs="true" :showPOILogo="true" :showPOIFloor="true">
				<template v-slot:poi="slotProps" >
					<ListPOI :poi="slotProps.poi" @onPOIClick="onPOIClick" :class="{'wf-active': currentPOI && currentPOI.id == slotProps.poi.id}"></ListPOI>
				</template>
			</WFSubGroupMenu-->
		</div>
	</div>
</template>

<script>
	import { WFScrollableArea,  WFGroupPOIsMenu} from '@3dwayfinder/wayfinder-vue-components'
	import ListPOI from './ListPOI.vue'

	import { mapState } from 'vuex';
	export default {
		components: {
			WFScrollableArea,
			ListPOI,
			WFGroupPOIsMenu
		},
		props: {
			slug: {
				default: "shops",
				type: String
			}
		},
		data() {
			return {
				currentGroup: null,
			}
		},
		computed: {
			...mapState('wf', ['language', 'loaded']),
			...mapState(['currentPOI', 'currentTab']),
		},
		mounted() {
			this.update();
		},
		watch: {
			slug() {
				this.update();
			},
			loaded () {
				this.update();
			}
		},
		methods: {
			onPOIClick (poi) {
				this.$store.commit('setLastTab', this.currentTab )
				this.$emit('clicked', poi);
			},
			update () {		
				let g = this.$wayfinder.getGroupWithSlug(this.slug);
				this.currentGroup = this.$store.getters["wf/freezeGroup"](Object.freeze(g));
				this.$nextTick(() => {
					if(this.$refs.groupscroll) {
						this.$refs.groupscroll.resize();
					this.$refs.groupscroll.reset();
					}
				});
			}
		}
	}
</script>
  
<style lang="postcss">
	.groupmenu {
		height: 100%;
		overflow: hidden;

		
	}
	
	.wf-group-pois-menu .wf-list {
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		row-gap: 1.2rem;
		column-gap: 2.4rem;
	}
  </style>